import { Table, Spin } from 'antd';
import PropTypes from 'prop-types';

const OCPPLogsTable = ({
  columns,
  dataSource,
  loading,
  error,
  emptyMessage,
  scrollY = "65vh",
  tableRef,
  ...rest
}) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center py-6">
        <Spin size="small" tip="Loading logs..." />
      </div>
    );
  }
  if (error) {
    return (
      <div className="text-red-500 text-center py-4">
        {error}
      </div>
    );
  }
  if (!dataSource || dataSource.length === 0) {
    return (
      <div className="flex justify-center items-center py-6 text-gray-500 font-medium">
        {emptyMessage || 'No logs to display.'}
      </div>
    );
  }
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      size="small"
      variant="outlined"
      scroll={{ y: scrollY }}
      className="w-full mt-4"
      ref={tableRef}
      {...rest}
    />
  );
};

OCPPLogsTable.propTypes = {
  columns: PropTypes.array.isRequired,
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  emptyMessage: PropTypes.string,
  scrollY: PropTypes.number,
  tableRef: PropTypes.any,
};

export default OCPPLogsTable; 